import polyfills from "./polyfills.js";
import React from "react";
import ReactDOM from "react-dom";
import styles from "./index.module.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
//import "bootstrap-v4-rtl/scss/bootstrap-rtl.scss"
import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import "./Accessability/accessability.css";
import { Provider } from "react-redux";

import store from "./store";
import { Container } from "reactstrap";

ReactDOM.render(
  <Provider store={store}>
    <Container className={styles.container}>
      <h1 className={styles.hiddenH1}>
        המפרט הכללי לעבודות הבניה (הספר הכחול)
      </h1>
      <App />
    </Container>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
